import type { Asset } from '@lumen5/luminary';

/**
 * Position an asset at a specific position, taking into account its anchor point.
 */
export function positionAsset(asset: Asset, position: { x: number; y: number }): void {
    const { width, height } = asset.getBounds();
    const anchorXOffset = asset.transformation.anchor.x * width;
    const anchorYOffset = asset.transformation.anchor.y * height;
    asset.transformation.position.x = position.x + anchorXOffset;
    asset.transformation.position.y = position.y + anchorYOffset;
}
